import axios from "axios";
import { apiHttp } from "../axiosApi.js";
import {
  allClaimsAdmin,
  auditedWeight,
  billingDador,
  billingParentDador,
  billingTomador,
  billingsAdmin,
  claim,
  claimAdmin,
  closeClaim,
  dadorToAdmin,
  dadorToParent,
  getReputation,
  getUserProfile,
  parentDadorChildren,
  purchaseVatBook,
  purchaseVatBookExport,
  rating,
  salesVatBook,
  salesVatBookExport,
  shippingNote,
  statisticsCore,
  statisticsDador,
  statisticsTomador,
  uploadPhoto,
  usersInvoicePending,
} from "../config/apiRoute.js";
import { TOMADOR_ID } from "../../constants/UserId.js";
const API_URL_BACKEND = process.env.REACT_APP_BACKEND_API;

export const getUserProfileAPI = (id) =>
  apiHttp("GET", `${getUserProfile}${id}`);

export const getUserReputation = (id) =>
  apiHttp("GET", `${getReputation}${id}`);

export const getUsers = (filters = {}) => {
  const {
    limit = 5,
    from = 0,
    search,
    cuit,
    role_id,
    status,
    tripState,
    validation,
    app,
    userType,
  } = filters;

  const queryObj = {
    limit,
    from,
    search,
    cuit,
    role_id,
    status,
    tripState,
    validation,
    app,
    userType,
  };
  const queryParams = Object.entries(queryObj)
    .filter(
      ([_, value]) =>
        value !== undefined && value !== null && value !== "" && value !== "0"
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  return apiHttp("GET", `${getUserProfile}?${queryParams}`);
};
export const getAllTomador = () => {
  return apiHttp("GET", `${getUserProfile}?role_id=${TOMADOR_ID}`);
};

export const getUsersByRoles = (limit = 5, from = 0, role = null) => {
  return apiHttp(
    "GET",
    `${getUserProfile}?limit=${limit}&from=${from}&role_id=${role}`
  );
};

export const getStatistics = () => {
  return apiHttp("GET", `${statisticsCore}`);
};

export const getStatisticsDador = (state) => {
  return apiHttp("GET", `${statisticsDador}${state ? `?state=${state}` : ""}`);
};

export const getStatisticsTomador = (state) => {
  return apiHttp(
    "GET",
    `${statisticsTomador}${state ? `?state=${state}` : ""}`
  );
};

export const patchTripDetails = (id, body) =>
  apiHttp("PATCH", `${auditedWeight}${id}`, body);

export const patchShippingNote = (id, body) =>
  apiHttp("PATCH", `${shippingNote}${id}`, body);

export const getUserPending = () => apiHttp("GET", `${usersInvoicePending}`);

export const getBillingsAdmin = ({ id_tomador, id_dador }) => {
  const queryString = id_tomador || id_dador ? "?" : "";
  const params = [];

  if (id_tomador) {
    params.push(`id_tomador=${id_tomador}`);
  }
  if (id_dador) {
    params.push(`id_dador=${id_dador}`);
  }

  return apiHttp("GET", `${billingsAdmin}${queryString}${params.join("&")}`);
};

export const getBillingsDador = () => {
  return apiHttp("GET", `${billingDador}`);
};

export const getBillingsParentDador = () => {
  return apiHttp("GET", `${billingParentDador}`);
};

export const getParentDadorChildren = () => {
  return apiHttp("GET", `${parentDadorChildren}`);
};
export const getBillingsTomador = () => {
  return apiHttp("GET", `${billingTomador}`);
};

export const getSalesVatBook = ({ year, month }) => {
  return apiHttp("GET", `${salesVatBook}?year=${year}&month=${month}`);
};

export const downloadSalesVatBook = ({ year, month }) => {
  const token = localStorage?.token;
  return axios.get(
    `${API_URL_BACKEND}${salesVatBookExport}?year=${year}&month=${month}`,
    {
      responseType: "blob",
      headers: {
        Authorization: `${token}`,
        device: "WEB",
      },
    }
  );
};

export const getPurchaseVatBook = ({ year, month }) => {
  return apiHttp("GET", `${purchaseVatBook}?year=${year}&month=${month}`);
};

export const downloadPurchaseVatBook = ({ year, month }) => {
  const token = localStorage?.token;
  return axios.get(
    `${API_URL_BACKEND}${purchaseVatBookExport}?year=${year}&month=${month}`,
    {
      responseType: "blob",
      headers: {
        Authorization: `${token}`,
        device: "WEB",
      },
    }
  );
};

export const putUserProfileAPI = (id, body) =>
  apiHttp("PUT", `${getUserProfile}${id}`, body);

export const putDadorToAdmin = (body) =>
  apiHttp("PUT", `${dadorToAdmin}`, body);

export const putDadorToParent = (body) =>
  apiHttp("PUT", `${dadorToParent}`, body);

export const getUploadPhoto = (id) =>
  axios.get(`${API_URL_BACKEND}${uploadPhoto}/${id}`, {
    responseType: "arraybuffer",
  });

export const putUploadPhoto = (id, formData) => {
  return axios.put(`${API_URL_BACKEND}${uploadPhoto}/${id}`, formData, {
    responseType: "arraybuffer",
  });
};

export const postRating = (body) => {
  return apiHttp("POST", `${rating}/`, body);
};

export const getRating = ({ order, score, tripId, postId, limit, from }) => {
  return apiHttp(
    "GET",
    `${rating}?${tripId ? `&tripId=${tripId}` : ""}${
      postId ? `&postId=${postId}` : ""
    }${score ? `&stars=${score}` : ""}${order ? `&order=${order}` : ""}${
      limit ? `&limit=${limit}` : ""
    }${from ? `&from=${from}` : ""}`
  );
};

export const postClaim = (body) => {
  return apiHttp("POST", `${claim}/`, body);
};

export const putRating = (body) => {
  return apiHttp("PUT", `${rating}/`, body);
};
export const getClaims = (id) => {
  return apiHttp("GET", `${claim}/${id}`);
};

export const getClaimsAdmin = (id) => {
  return apiHttp("GET", `${claimAdmin}/${id}`);
};
export const putCloseClaim = (body) => {
  return apiHttp("PUT", `${closeClaim}/`, body);
};

export const getAllClaimsAdmin = ({
  limit,
  from = 0,
  state,
  cuitCreator,
  cuitClaimed,
  user_id,
}) => {
  return apiHttp(
    "GET",
    `${allClaimsAdmin}?limit=${limit}&from=${from}${
      user_id ? `&user_id=${user_id}` : ""
    }${state ? `&state=${state}` : ""}${
      cuitCreator ? `&cuitCreator=${cuitCreator}` : ""
    }${cuitClaimed ? `&cuitClaimed=${cuitClaimed}` : ""}`
  );
};